import React from 'react';

const SORT_ICON_SVG_MARKUP = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2.5 4h9M4 7h6M5.5 10h3" stroke="#2c3437" stroke-width="1.25" stroke-linecap="round"/></svg>`;

export const SORT_ICON_DATA_URI = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(SORT_ICON_SVG_MARKUP)}`;

export const SortIcon = ({
  width = 18,
  height = 18,
  className,
  stroke = '#E5E5E5',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M2.5 4h9M4 7h6M5.5 10h3"
      stroke={stroke}
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);